/**
 * @generated SignedSource<<785c892e9245a988daeeb8a41a7d91e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurriculumModuleListFragment$data = {
  readonly id: string;
  readonly modules: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentModuleListFragment">;
  };
  readonly " $fragmentType": "CurriculumModuleListFragment";
};
export type CurriculumModuleListFragment$key = {
  readonly " $data"?: CurriculumModuleListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurriculumModuleListFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentLabelIds"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./CurriculumModuleListRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CurriculumModuleListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "modules",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "contentLabelIds",
              "variableName": "contentLabelIds"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ContentModuleListFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Curriculum",
  "abstractKey": null
};

(node as any).hash = "356e217171f03bd67c59ec56f9c0d6bc";

export default node;
